class BeforeAfterComparison extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.range = this.querySelector('[data-before-after-range]');
    if (!this.range) return;

    this.updatePosition = () => {
      const position = Math.max(0, Math.min(100, Number(this.range.value) || 0));
      this.style.setProperty('--bac-position', `${position}%`);
      this.range.setAttribute('aria-valuenow', String(position));
    };

    this.range.addEventListener('input', this.updatePosition);
    this.range.addEventListener('change', this.updatePosition);
    this.updatePosition();
  }

  disconnectedCallback() {
    this.range?.removeEventListener('input', this.updatePosition);
    this.range?.removeEventListener('change', this.updatePosition);
  }
}

if (!customElements.get('before-after-comparison')) {
  customElements.define('before-after-comparison', BeforeAfterComparison);
}
